import styled from 'styled-components';

export const StyledHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  padding: 4px 0 20px;
  margin-bottom: 8px;
  background: linear-gradient(180deg, var(--body-bg) 70%, transparent 100%);

  .header-left {
    flex: 1;
    min-width: 200px;
  }

  .greeting {
    display: block;
    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    color: var(--text-color-50);
    margin-bottom: 4px;
  }

  .page-title {
    font-family: var(--font-heading);
    font-size: 22px;
    line-height: 28px;
    font-weight: 800;
    color: var(--ink);
    margin: 0 0 4px;
    letter-spacing: -0.025em;

    @media (min-width: 768px) {
      font-size: 26px;
      line-height: 32px;
    }
  }

  .page-subtitle {
    font-size: 14px;
    line-height: 20px;
    color: var(--text-color-50);
    margin: 0;
    max-width: 480px;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  .help-chip {
    display: none;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border-radius: 999px;
    border: 1px solid var(--line);
    background: var(--card-bg);
    color: var(--ink);
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    transition: all 0.2s ease;

    svg {
      color: var(--gold);
      flex-shrink: 0;
    }

    @media (min-width: 768px) {
      display: inline-flex;
    }

    &:hover {
      border-color: rgba(10, 77, 162, 0.35);
      color: var(--blue);
      background: var(--line-soft);
    }
  }
`;
